<script setup>
// NOTICE: KAPTION-INTEGRATION
// ai-connectors.FLAG.1: picks the consent page. With KAPTION_AI_CONNECTORS on
// in any of the person's accounts they get the role-based page; otherwise the
// existing one, unchanged. The route has no account, so the server decides.
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import kaptionMcpGrant from 'dashboard/api/kaptionMcpGrant';
import LegacyConsent from './Index.vue';
import KaptionAiConsent from 'dashboard/components/kaption/KaptionAiConnectors/KaptionAiConsent.vue';

const route = useRoute();
const oreq = computed(() => String(route.query.oreq || ''));

// Display-only decode of the blob payload ({i: oauthReqInfo, c: clientName}).
// Integrity is the worker's job: it re-verifies the HMAC on completion.
const clientName = computed(() => {
  try {
    const payload = oreq.value.split('.')[0];
    const b64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    const decoded = JSON.parse(atob(padded));
    return decoded.c || decoded.i?.clientId || 'MCP client';
  } catch (e) {
    return '';
  }
});

const ready = ref(false);
const useNew = ref(false);
const twoFaVerified = ref(false);

onMounted(async () => {
  if (oreq.value && clientName.value) {
    try {
      const { data } = await kaptionMcpGrant.getStatus();
      useNew.value = !!data.ai_connectors;
      twoFaVerified.value = !!data.two_fa_verified;
    } catch (e) {
      // feature off or not reachable: the legacy page explains itself
    }
  }
  ready.value = true;
});
</script>

<template>
  <div v-if="!ready" class="w-full min-h-screen bg-n-background" />
  <KaptionAiConsent
    v-else-if="useNew"
    :oreq="oreq"
    :client-name="clientName"
    :two-fa-verified="twoFaVerified"
  />
  <LegacyConsent v-else />
</template>
